import axios, { AxiosResponse } from 'axios';
import apiPaths from 'enums/apiPaths';

export interface IPlatba {
    token: string;
    idzadosti: string;
    email?: string;
    telefon?: string;
}

export interface IPlatbaData {
    code?: number;
    message?: string;
}

const objednatApi = (token: string, idzadosti: string, email?: string, telefon?: string) => {
    return axios({
        method: 'POST',
        url: apiPaths.OBJEDNAT,
        headers: {
            Authorization: `Bearer ${token}`
        },
        data: {
            idzadosti,
            email,
            telefon
        }
    }).then((resp: AxiosResponse<IPlatbaData>) => resp);
};

export default objednatApi;
